import { Mail } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { APP_NAME, CONTACT_EMAIL } from "@/constants/site";

const Footer = () => (
  <footer className="border-t border-white/10" data-testid="site-footer">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-6 py-16 sm:flex-row sm:items-center">
      <div>
        <div className="flex items-center gap-3">
          <Logo size={32} />
          <span className="font-heading text-base font-bold tracking-tight text-white">{APP_NAME}</span>
        </div>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-500">
          Video streaming and social media, crafted for iOS.
        </p>
      </div>
      <div className="flex flex-col items-start gap-3">
        <p className="font-mono text-[11px] font-medium uppercase tracking-[0.25em] text-slate-500">
          Contact Us
        </p>
        <a
          href={`mailto:${CONTACT_EMAIL}`}
          data-testid="contact-email-link"
          className="group inline-flex items-center gap-3 rounded-full border border-white/10 bg-white/[0.04] px-5 py-3 transition-colors duration-300 hover:border-crimson/40 hover:bg-crimson/10"
        >
          <Mail size={16} className="text-crimson" />
          <span className="font-heading text-sm font-semibold text-white sm:text-base">
            {CONTACT_EMAIL}
          </span>
        </a>
      </div>
    </div>
    <div className="border-t border-white/5">
      <div className="mx-auto flex max-w-7xl flex-col gap-2 px-6 py-6 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-5">
          <p className="text-xs text-slate-600">© 2026 {APP_NAME}. All rights reserved.</p>
          <Link
            to="/privacy-policy"
            data-testid="footer-privacy-link"
            className="text-xs text-slate-500 underline-offset-4 transition-colors duration-300 hover:text-white hover:underline"
          >
            Privacy Policy
          </Link>
        </div>
        <p className="text-xs text-slate-600">
          Apple, the Apple logo, and iOS are trademarks of Apple Inc.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
